const payment = () => {
    $(window).on('load', function () {
        if ($('#paymentTransactionTable').length > 0) {
            var table = $('#paymentTransactionTable').DataTable({
                processing: true,
                serverSide: true,
                ajax: baseUrl +'/publisher/payment/transaction',
                columns: [
                    {data: 'DT_RowIndex', name: 'DT_RowIndex'},
                    {data: 'transaction_id', name: 'transaction_id'},
                    {data: 'amount', name: 'amount'},
                    {data: 'message_code', name: 'message_code'},
                    {data: 'message_desc', name: 'message_desc'},
                    {data: 'created_at', name: 'created_at'},
                ]
            });
        }

        $('#placeOrderForm').on('submit',function(e){
            $(".spinner-border").show();
            $("#overlay").show();
        });

        if ($('#walletTransactionTable').length > 0) {

            var table = $('#walletTransactionTable').DataTable({
                processing: true,
                serverSide: true,
                ajax: baseUrl +'/publisher/wallet/transaction',
                columns: [
                    {data: 'DT_RowIndex', name: 'DT_RowIndex'},
                    {data: 'type', name: 'type'},
                    {data: 'transaction_id', name: 'transaction_id'},
                    {data: 'amount', name: 'amount'},
                    {data: 'description', name: 'description'},
                    {data: 'done_by', name: 'done_by'},
                    {data: 'created_at', name: 'created_at'},
                ]
            });

        }

        var valid = require("card-validator");

        $('#cvv').on("keyup",function(){
            var cvv = $('#cvv').val();

            var cvvValidation = valid.cvv(cvv);

            if (!cvvValidation.isValid) {
                this.setCustomValidity('CVV number is invalid');
            }else{
                this.setCustomValidity('');
            }
        });

        $('#card_number').on("keyup",function(){
            var cardNumber = $(this).val().split("-").join(""); // remove hyphens
            if (cardNumber.length > 0) {
                cardNumber = cardNumber.match(new RegExp('.{1,4}', 'g')).join("-");
            }
            $(this).val(cardNumber);

            var cardNumber = $(this).val().replace(/\-/g, '');
        
            var numberValidation = valid.number(cardNumber);
            
            if (!numberValidation.isValid) {
                this.setCustomValidity('Card number is invalid');
            }else{
                this.setCustomValidity('');
            }
        });

        $('#expiration_date').on("keyup",function(){
            let date = $(this).val();
            if (date.length == 2) {
                date = date+'/';
                $(this).val(date);
            }
            var expiration_date = valid.expirationDate(date);

            if (!expiration_date.isValid) {
                this.setCustomValidity('Expiry date is invalid');
            }else{
                this.setCustomValidity('');
            }
        });
    })
}
export default payment;